<template>
  <div>
    <div class="title--area">
      <h2>{{ menuNm }}</h2>
    </div>
    <div class="data--container" v-resize @resize="onResize">
      <div class="flex--box flex--box--1_2 btn--on">
        <div class="btn--area space--between">
          <button type="button" class="btn btn--black" @click="add">추가</button>
          <div class="btns">
            <button type="button" class="btn btn--white" @click="save">저장</button>
            <button type="button" class="btn btn--white" @click="del">삭제</button>
          </div>
        </div>
        <div class="grid--area">
          <grid ref="grid1"
              :data="gridProps.data"
              :columns="gridProps.columns"
              :options="gridProps.options"
              :language="'ko'"
              @click="gridClick"
              @check="gridCheck"
              >
          </grid>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'tui-date-picker/dist/tui-date-picker.css'
import 'tui-time-picker/dist/tui-time-picker.css'
import { Grid } from '@toast-ui/vue-grid'
import menuMngApi from '@/api/admin/MenuMng'

export default {
  name: 'MenuMng',
  components: {
    grid: Grid
  },

  data () {
    return {
      menuNm: this.$route.name,
      gridProps: {
        data: [],
        columns: [
          {
            header: '레벨',
            name: 'level'
          },
          {
            header: '메뉴ID',
            name: 'menuId',
            width: 250,
            editor: 'text'
          },
          {
            header: 'upId',
            name: 'upperMenuId',
            width: 250,
            editor: 'text'
          },
          {
            header: '메뉴명',
            name: 'menuNm',
            align: 'left',
            width: 250,
            editor: 'text'
          },
          {
            header: '프로그램경로',
            name: 'programPath',
            align: 'left',
            width: 200,
            editor: 'text'
          },
          {
            header: '메뉴경로',
            name: 'menuPath',
            width: 200,
            align: 'left',
            editor: 'text'
          },
          {
            header: '순서',
            name: 'orderinlevel',
            width: 80,
            align: 'center',
            editor: 'text'
          },
          {
            header: '메뉴설명',
            name: 'menuDescription',
            width: 200,
            align: 'left',
            editor: 'text'
          },
          {
            header: '사용여부',
            name: 'useYn',
            align: 'center',
            formatter: 'listItemText',
            editor: {
              type: 'select',
              options: {
                listItems: [
                  { text: '예', value: 'Y' },
                  { text: '아니오', value: 'N' }
                ]
              }
            }
          },
          {
            header: '보기여부',
            name: 'viewYn',
            align: 'center',
            formatter: 'listItemText',
            editor: {
              type: 'select',
              options: {
                listItems: [
                  { text: '예', value: 'Y' },
                  { text: '아니오', value: 'N' }
                ]
              }
            }
          }
        ],
        options: {
          rowHeaders: ['checkbox'],
          header: {
            height: 40
          },
          columnOptions: {
            resizable: true
          },
          bodyHeight: 550,
          selectionUnit: 'row',
          scrollX: true,
          scrollY: true,
          editingEvent: 'dblclick',
          treeColumnOptions: {
            name: 'menuNm',
            useIcon: true,
            useCascadingCheckbox: true
          }
        }
      },
      rowKey: null,
      attribute: {
        expanded: true
      }
    }
  },
  mounted () {
  },
  created () {
    this.searchGridData()
  },
  methods: {
    onResize () {
      this.$refs.grid1.invoke('refreshLayout')
    },
    async searchGridData () {
      const params = {}
      const menuTreeList = await menuMngApi.selectMenuMngList(params)
      this.gridProps.data = menuTreeList

      if (this.gridProps.data !== undefined) {
        this.$set(this.gridProps.data[0], '_attributes', this.attribute) // 1depth 트리 expand 적용

        for (let i = 0; i < this.gridProps.data[0]._children.length; i++) { // 2depth 까지 트리 expand 적용
          this.$set(this.gridProps.data[0]._children[i], '_attributes', this.attribute)
        }

        this.$refs.grid1.invoke('resetData', this.gridProps.data)
        // 컬럼 숨김 설정
        this.$refs.grid1.invoke('hideColumn', 'level')
        // this.$refs.grid1.invoke('hideColumn', 'menuId')
        this.$refs.grid1.invoke('hideColumn', 'upperMenuId')
      }
    },

    async save () { // 그리드 내 입력, 수정 event

      const params = this.$refs.grid1.invoke('getModifiedRows')
      if (params.createdRows.length === 0 && params.updatedRows.length === 0) { // 추가 또는 수정된 row가 없다면 이벤트 없이 return
        return
      }

      const rowCnt = this.$refs.grid1.invoke('getRowCount')

      for (let i = 0; i < rowCnt; i++) {
        const parentRowKey = this.$refs.grid1.invoke('getRowAt', i)._attributes.tree.parentRowKey
        const menuNm = this.$refs.grid1.invoke('getRowAt', i).menuNm
        const programPath = this.$refs.grid1.invoke('getRowAt', i).programPath
        const menuPath = this.$refs.grid1.invoke('getRowAt', i).menuPath
        const orderinlevel = this.$refs.grid1.invoke('getRowAt', i).orderinlevel

        if (parentRowKey !== null && parentRowKey !== 0) {
          if (menuNm == null || menuNm === '') {
            alert('메뉴명을 입력해주세요!')
            this.$refs.grid1.invoke('focusAt', i, 1)
            return
          } else if (programPath == null || programPath === '') {
            alert('프로그램 경로를 입력해주세요!')
            this.$refs.grid1.invoke('focusAt', i, 2)
            return
          } else if (menuPath == null || menuPath === '') {
            alert('메뉴경로를 입력해주세요!')
            this.$refs.grid1.invoke('focusAt', i, 3)
            return
          } else if (orderinlevel == null || orderinlevel === '') {
            alert('순서를 입력해주세요!')
            this.$refs.grid1.invoke('focusAt', i, 4)
            return
          }
        } else if (parentRowKey === 0) {
          if (menuNm == null || menuNm === '') {
            alert('메뉴명을 입력해주세요!')
            this.$refs.grid1.invoke('focus', i, 'menuNm')
            return
          } else if (menuPath == null || menuPath === '') {
            alert('메뉴경로를 입력해주세요!')
            this.$refs.grid1.invoke('focus', i, 'menuPath')
            return
          } else if (orderinlevel == null || orderinlevel === '') {
            alert('순서를 입력해주세요!')
            this.$refs.grid1.invoke('focus', i, 'orderinlevel')
            return
          }
        }
      }

      if (window.confirm('저장하시겠습니까?')) {
        const params = this.$refs.grid1.invoke('getModifiedRows') // createdRows, updatedRows, deletedRows

        const result = await menuMngApi.saveMenuMng(params)

        if (result.result) {
          alert('저장되었습니다.')
          this.searchGridData()
        } else {
          alert('오류가 발생했습니다. 다시 시도해주세요.')
        }
      }
    },

    add () { // row 추가
      if (this.rowKey == null) {
        alert('상위 목록을 선택해주세요.')
      } else {
        const parentRowKey = this.$refs.grid1.invoke('getRowAt', this.rowKey)._attributes.tree.parentRowKey

        if (parentRowKey != null && parentRowKey !== 0) {
          alert('추가할 수 없습니다.')
          return
        }

        const upperMenuId = this.$refs.grid1.invoke('getValue', this.rowKey, 'menuId')

        if (upperMenuId == null) {
          alert('상위 목록을 먼저 저장해주세요.')
        } else {
          this.$refs.grid1.invoke('appendRow', { upperMenuId: upperMenuId, useYn: 'Y', viewYn: 'Y' }, { parentRowKey: this.rowKey, focus: false })
        }
      }
    },

    async del () { // 그리드 내 삭제 event
      const params = this.$refs.grid1.invoke('getCheckedRows') // check 된 row만 삭제
      if (params.length > 0) {
        if (window.confirm('삭제하시겠습니까?')) {
          const result = await menuMngApi.deleteMenuMng(params)

          if (result.result) {
            alert('삭제되었습니다.')
            this.searchGridData()
          } else {
            alert('오류가 발생했습니다. 다시 시도해주세요.')
          }
        }
      } else {
        alert('삭제하실 항목을 선택해주세요.')
      }
    },

    gridClick (ev) {
      if (ev.targetType === 'cell') {
        this.rowKey = ev.rowKey
      }
    },

    gridCheck (ev) {
      if (this.$refs.grid1.invoke('getValue', ev.rowKey, 'menuId') == null) {
        this.$refs.grid1.invoke('removeRow', ev.rowKey)
      }
    }
  }
}
</script>

<style>
</style>
